import { render } from "./AttirePage.vue?vue&type=template&id=9b86775a"
import script from "./AttirePage.vue?vue&type=script&lang=js"
export * from "./AttirePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__